// Mock data for products - replace with actual API calls
const mockProducts = [
  {
    id: 1,
    name: "Wireless Bluetooth Headphones",
    price: 99.99,
    originalPrice: 129.99,
    image:
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop",
    category: "Electronics",
    brand: "AudioTech",
    rating: 4.5,
    reviews: 120,
    inStock: true,
    description: "High-quality wireless headphones with noise cancellation",
  },
  {
    id: 2,
    name: "Smart Fitness Watch",
    price: 199.99,
    originalPrice: 249.99,
    image:
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=400&fit=crop",
    category: "Electronics",
    brand: "FitTrack",
    rating: 4.3,
    reviews: 89,
    inStock: true,
    description: "Advanced fitness tracking with heart rate monitor",
  },
  {
    id: 3,
    name: "Casual Cotton T-Shirt",
    price: 24.99,
    originalPrice: 34.99,
    image:
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop",
    category: "Clothing",
    brand: "ComfortWear",
    rating: 4.2,
    reviews: 45,
    inStock: true,
    description: "Soft, comfortable cotton t-shirt for everyday wear",
  },
  {
    id: 4,
    name: "Running Sneakers",
    price: 89.99,
    originalPrice: 119.99,
    image:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop",
    category: "Shoes",
    brand: "RunFast",
    rating: 4.6,
    reviews: 203,
    inStock: true,
    description: "Lightweight running shoes with excellent cushioning",
  },
  {
    id: 5,
    name: "Leather Wallet",
    price: 45.99,
    originalPrice: 65.99,
    image:
      "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
    category: "Accessories",
    brand: "LeatherCraft",
    rating: 4.4,
    reviews: 67,
    inStock: false,
    description: "Premium leather wallet with multiple card slots",
  },
  {
    id: 6,
    name: "Gaming Keyboard",
    price: 79.99,
    originalPrice: 99.99,
    image:
      "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=400&h=400&fit=crop",
    category: "Electronics",
    brand: "GamePro",
    rating: 4.7,
    reviews: 156,
    inStock: true,
    description: "Mechanical gaming keyboard with RGB backlighting",
  },
  {
    id: 7,
    name: "Denim Jeans",
    price: 59.99,
    originalPrice: 79.99,
    image:
      "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=400&h=400&fit=crop",
    category: "Clothing",
    brand: "DenimStyle",
    rating: 4.1,
    reviews: 78,
    inStock: true,
    description: "Classic fit denim jeans with modern styling",
  },
  {
    id: 8,
    name: "Coffee Maker",
    price: 149.99,
    originalPrice: 199.99,
    image:
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=400&fit=crop",
    category: "Home & Kitchen",
    brand: "BrewMaster",
    rating: 4.5,
    reviews: 92,
    inStock: true,
    description: "Programmable coffee maker with thermal carafe",
  },
];

export const productService = {
  // Get all products with optional filtering
  getProducts: async (filters = {}) => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    let filteredProducts = [...mockProducts];

    // Apply category filter
    if (filters.category && filters.category !== "all") {
      filteredProducts = filteredProducts.filter(
        (product) =>
          product.category.toLowerCase() === filters.category.toLowerCase()
      );
    }

    // Apply brand filter
    if (filters.brand && filters.brand.length > 0) {
      filteredProducts = filteredProducts.filter((product) =>
        filters.brand.includes(product.brand)
      );
    }

    // Apply price range filter
    if (filters.minPrice !== undefined) {
      filteredProducts = filteredProducts.filter(
        (product) => product.price >= filters.minPrice
      );
    }

    if (filters.maxPrice !== undefined) {
      filteredProducts = filteredProducts.filter(
        (product) => product.price <= filters.maxPrice
      );
    }

    // Apply in stock filter
    if (filters.inStock) {
      filteredProducts = filteredProducts.filter((product) => product.inStock);
    }

    // Apply rating filter
    if (filters.minRating) {
      filteredProducts = filteredProducts.filter(
        (product) => product.rating >= filters.minRating
      );
    }

    // Apply search query
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      filteredProducts = filteredProducts.filter(
        (product) =>
          product.name.toLowerCase().includes(searchLower) ||
          product.description.toLowerCase().includes(searchLower) ||
          product.brand.toLowerCase().includes(searchLower)
      );
    }

    // Apply sorting
    if (filters.sortBy) {
      switch (filters.sortBy) {
        case "price-low":
          filteredProducts.sort((a, b) => a.price - b.price);
          break;
        case "price-high":
          filteredProducts.sort((a, b) => b.price - a.price);
          break;
        case "rating":
          filteredProducts.sort((a, b) => b.rating - a.rating);
          break;
        case "name":
          filteredProducts.sort((a, b) => a.name.localeCompare(b.name));
          break;
        default:
          // Default sorting by popularity (reviews count)
          filteredProducts.sort((a, b) => b.reviews - a.reviews);
      }
    }

    return {
      products: filteredProducts,
      total: filteredProducts.length,
    };
  },

  // Get product by ID
  getProductById: async (id) => {
    await new Promise((resolve) => setTimeout(resolve, 300));
    return mockProducts.find((product) => product.id === parseInt(id));
  },

  // Get all available categories
  getCategories: async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    const categories = [
      ...new Set(mockProducts.map((product) => product.category)),
    ];
    return categories;
  },

  // Get all available brands
  getBrands: async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    const brands = [...new Set(mockProducts.map((product) => product.brand))];
    return brands;
  },
};
